// extracted by mini-css-extract-plugin
module.exports = {"root":"TicketTierRow_root__iiCfI","copy":"TicketTierRow_copy___7CS7","removeButton":"TicketTierRow_removeButton__decf7"};